import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CaveatService } from '@products/caveats/services/caveat.service';
import { BaseEntryProductComponent } from '@products/base-entry-product-component';
import { Subscription } from 'rxjs';
import { TranslateService } from '@shared/translate/translate.service';
import { ProductDetailConfiguration } from '@types';
import { SiteConfigService } from '@services/site-config.service';

interface LegalCaveatConfig extends ProductDetailConfiguration {
  placement: string;
  legalTitle: boolean;
  showFootnotesTitle: boolean;
  showFootnotes: boolean;
}

@Component({
  selector: 'ft-legal-caveats',
  templateUrl: './legal-caveats.component.html',
  styleUrls: ['./legal-caveats.component.scss'],
})
export class LegalCaveatsComponent
  extends BaseEntryProductComponent
  implements OnInit, OnDestroy {
  footnotesTitle: string;
  footnotes: string[] = [];
  legals: string[] = [];
  subs: Subscription[] = [];
  importantLegalTitle = '';
  placement: string;
  directCaveats: string[];
  isSiteIntl: boolean;

  constructor(
    private caveatService: CaveatService,
    private translateService: TranslateService,
    private changeDetector: ChangeDetectorRef,
    private siteConfigService: SiteConfigService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    const brConfig = this.brConfig as LegalCaveatConfig;
    this.placement = brConfig?.placement;
    this.directCaveats = this.component?.getModels()?.directCaveats;
    this.caveatService.setCaveatFilter(this.fundId, this.shareClassCode);
    this.subs.push(
      this.caveatService
        .getLegals$(this.placement, this.directCaveats)
        .subscribe((legals) => {
          this.legals = legals;
          this.changeDetector.detectChanges();
        })
    );
    if (brConfig?.legalTitle) {
      this.importantLegalTitle = this.translateService.instant(
        'products.important-legal-title'
      );
    }
    if (brConfig?.showFootnotesTitle) {
      this.footnotesTitle = this.translateService.instant(
        'products.footnotes-title'
      );
    }
    if (brConfig?.showFootnotes) {
      this.subs.push(
        this.caveatService.getFootnoteContents$().subscribe((footnotes) => {
          this.footnotes = footnotes;
          this.changeDetector.detectChanges();
        })
      );
    }
    this.isSiteIntl = this.siteConfigService.isSiteInternational();
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
